<!-- AutoSuggest.vue -->
<template>
  <div class="auto-suggest">
    <input
      ref="inputEl"
      type="text"
      :id="name"
      :name="name"
      placeholder="Start typing..."
      maxlength="40"
      :pattern="regexPattern"
      autocomplete="off"
      required
      :value="modelValue"
      @input="onInput"
      :class="{ 'no-suggestions': filteredSuggestions.length === 0 && query }"
    />

    <div v-if="filteredSuggestions.length" class="suggestions">
      <div
        v-for="(item, index) in filteredSuggestions"
        :key="index"
        class="suggestion-item"
        @click="selectSuggestion(item)"
      >
        {{ item }}
      </div>
    </div>

    <br/>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'

const props = defineProps({
  suggestions: {
    type: Array,
    default: () => []
  },
  regexPattern: {
    type: String,
    default: "[A-Za-z0-9' ]*"
  },
  name: {
    type: String,
    default: 'pensionProviderName'
  },
  modelValue: {
    type: String,
    default: ''
  }
})

const emit = defineEmits(['update:modelValue'])

const inputEl = ref(null)
const query = ref('')

const onInput = (event) => {
  const value = event.target.value
  emit('update:modelValue', value) // send value back to parent
  query.value = value.toLowerCase()
}

const filteredSuggestions = computed(() => {
  if (!query.value) return []
  return props.suggestions.filter(s =>
    s.toLowerCase().includes(query.value)
  )
})

const selectSuggestion = (value) => {
  emit('update:modelValue', value)
  query.value = ''
}
</script>

<style scoped>

form input[type=text] {
  margin-bottom:0px;
  padding-bottom: 0px;
}

.auto-suggest {
  position: relative;
}

.suggestions {
  border: 1px solid #ccc;
  max-height: 150px;
  overflow-y: auto;
  position: absolute;
  background: white;
  width: 100%;
  z-index: 1000;
}

.suggestion-item {
  padding: 8px;
  cursor: pointer;
}

.suggestion-item:hover {
  background-color: #f0f0f0;
}


</style>
